module.exports = __webpack_public_path__ + "static/snowball-testimonials-3-5e1cb28d0e3aeabbad5347d5b56f6f7c.jpg";